import { alpha, buttonClasses } from "@mui/material"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(
  ({ breakpoints, spacing, palette, shadows }) => ({
    root: {
      display: "flex",
      [breakpoints.down("md")]: {
        flexDirection: "column"
      }
    },
    paper: {
      borderRadius: "4px",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      boxShadow: shadows[1],
      minWidth: "auto"
    },
    mainButton: {
      backgroundColor: palette.primary[700],
      transition: "border-radius 0.25s ease-out",
      color: "#fff",
      padding: spacing(2, 5),
      fontSize: "0.9375rem",
      minWidth: 112,
      minHeight: 46,
      "&:hover": {
        backgroundColor: palette.primary[800]
      },
      "&[aria-controls=programs-dropdown-menu]": {
        backgroundColor: "white",
        color: palette.primary.main,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      },
      [breakpoints.down("md")]: {
        width: "100%",
        justifyContent: "space-between"
      },
      "&:focus, &:focus-visible": {
        outline: `2px solid ${alpha(lightBlue[200], 0.2)}`,
        border: `1px solid ${lightBlue[300]}`
      },
      [`&:disabled, &.${buttonClasses.disabled}`]: {
        boxShadow: "none !important",
        cursor: "default",
        color: "#fff",
        backgroundColor: palette.primary[700]
      }
    },
    mainButtonIcon: {
      fontSize: "0.6875rem !important",
      marginLeft: spacing(2)
    },
    menuList: {
      color: palette.primary[500],
      fontSize: "0.6875rem",
      padding: spacing(2, 0)
    },
    menuListItem: {
      color: blueGrey[500],
      paddingBottom: spacing(2),
      paddingTop: spacing(2)
    }
  })
)
